'use strict';

var React = require('react');

var SvgDomainIcon = function SvgDomainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3c-.414 0-.75.336-.75.75v9c0 .414.336.75.75.75s.75-.336.75-.75v-8.25h10.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 6.25c0-.414.336-.75.75-.75h10.5c.414 0 .75.336.75.75v3.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.5h-9v5h4c.414 0 .75.336.75.75s-.336.75-.75.75h-4.75c-.414 0-.75-.336-.75-.75v-9Zm10.5.75v1h-9v-1h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.565 10.96c-.17-.043-.35.007-.474.131s-.174.304-.132.474l1.122 4.51c.043.176.177.314.351.362.174.048.36-.001.487-.128l1.165-1.165.84.841c.196.196.512.196.708 0l.353-.353c.196-.195.196-.512 0-.707l-.84-.841 1.163-1.165c.128-.127.177-.313.129-.487-.049-.174-.187-.308-.361-.351l-4.51-1.122Z"
  }));
};
SvgDomainIcon.displayName = "DomainIcon";

exports.SvgDomainIcon = SvgDomainIcon;
